// Réglages → Aussi sur ntfy (lot 6.6) : pour les avertis, une copie des notifications sur le serveur ntfy de leur choix.
// Aucun serveur par défaut : le texte des notifications passe par lui, c'est à la personne de le choisir en connaissance
// de cause. Le jeton n'est jamais réaffiché.

import { useEffect, useState } from 'react';

import type { Actions } from '../App';
import { Fenetre } from '../components';
import { type ReglageNtfy, api } from '../lib/api';

export function CarteNtfy({ actions }: { actions: Actions }) {
  const [reglage, setReglage] = useState<ReglageNtfy | null>(null);
  const [url, setUrl] = useState('');
  const [topic, setTopic] = useState('');
  const [jeton, setJeton] = useState('');
  const [occupe, setOccupe] = useState(false);

  const recevoir = (r: ReglageNtfy) => {
    setReglage(r);
    setUrl(r.serveur?.url ?? '');
    setTopic(r.serveur?.topic ?? '');
    setJeton('');
  };
  useEffect(() => {
    void api.reglageNtfy().then(recevoir).catch(() => undefined);
  }, []);

  const faire = async (f: () => Promise<void>) => {
    setOccupe(true);
    try {
      await f();
    } catch (e) {
      actions.toast({ texte: (e as Error).message, erreur: true });
    } finally {
      setOccupe(false);
    }
  };
  const enregistrer = () => faire(async () => {
    // Champ du jeton vide : on garde celui qui existe (le cœur le retire si le serveur change).
    recevoir(await api.reglerNtfy(url, topic, jeton || undefined));
    actions.toast({ texte: 'Canal ntfy enregistré.' });
  });
  const essayer = () => faire(async () => {
    await api.essaiNtfy();
    actions.toast({ texte: 'Essai envoyé : regardez l’app ntfy.' });
  });
  const desactiver = () => faire(async () => {
    await api.retirerNtfy();
    recevoir({ serveur: null, cloud: reglage?.cloud ?? false });
    actions.toast({ texte: 'Plus rien ne part sur ntfy.' });
  });

  if (!reglage) return null;
  const s = reglage.serveur;
  return (
    <Fenetre>
      <span className="display" style={{ fontWeight: 500 }}>Aussi sur ntfy</span>
      <p className="muted" style={{ margin: 0, fontSize: 13, lineHeight: 1.45 }}>
        Pour les avertis : une copie de chaque notification sur l’app ntfy, souvent plus fiable sur iPhone. Facultatif : Alfred
        ne propose aucun serveur.
      </p>
      <p style={{ margin: 0, fontSize: 13, lineHeight: 1.45 }}>
        <strong>À savoir.</strong> Le texte de vos notifications (rappels, brief) passe par ce serveur : choisissez-en un de
        confiance. Sur un serveur public, quiconque connaît le sujet peut les lire : prenez un sujet difficile à deviner, ou un jeton.
      </p>
      {s?.briefSeul && <p className="muted" style={{ margin: 0, fontSize: 13 }}>Seul le brief y part pour l’instant. Enregistrez pour y recevoir toutes les notifications.</p>}
      <form className="formulaire" onSubmit={(e) => { e.preventDefault(); void enregistrer(); }}>
        <label className="champ-compte">
          Serveur
          <input className="saisie texte" type="url" inputMode="url" autoComplete="off" required placeholder={reglage.cloud ? 'https://…' : 'https://… ou http://…'} value={url} onChange={(e) => setUrl(e.target.value)} />
        </label>
        <label className="champ-compte">
          Sujet
          <input className="saisie texte" autoComplete="off" autoCapitalize="none" required maxLength={64} value={topic} onChange={(e) => setTopic(e.target.value)} />
        </label>
        <label className="champ-compte">
          Jeton (facultatif)
          <input className="saisie texte" type="password" autoComplete="off" placeholder={s?.aJeton ? 'Enregistré : laissez vide pour le garder' : ''} value={jeton} onChange={(e) => setJeton(e.target.value)} />
        </label>
        <button className={`btn${s && !s.briefSeul ? '' : ' principal'}`} disabled={occupe}>Enregistrer</button>
      </form>
      {s && (
        <div className="boutons">
          {!s.briefSeul && <button className="btn" disabled={occupe} onClick={() => void essayer()}>Envoyer un essai</button>}
          <button className="btn" disabled={occupe} onClick={() => void desactiver()}>Désactiver</button>
        </div>
      )}
    </Fenetre>
  );
}
